import React from 'react';
import css from './GifCategoryItem.module.css';

interface GifCategoryItemProps {
    gif: string;
}

const GifCategoryItem: React.FC<GifCategoryItemProps> = ({ gif }) => {
    return (
        <div className={css.categoryContainer}>
            <img src={gif} className={css.gif} />
        </div>
    );
};

export default GifCategoryItem;
